export default "__VITE_ASSET__DhInAS2f__"